/** Matches prototype's .field-group — margin-bottom: 28px. */
export function FieldGroup({ children }: { children: React.ReactNode }) {
  return <div style={{ marginBottom: 28 }}>{children}</div>;
}
